import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Tabs, Tab } from '@material-ui/core';
import { useIntl } from 'react-intl';

const useStyles = makeStyles(theme => ({
  tabs: {
    flexGrow: 1,
    minHeight: theme.spacing(5),
    '& .MuiTabs-indicator': {
      backgroundColor: theme.palette.primary.main,
      height: theme.spacing(0.25)
    }
  },
  tab: {
    ...theme.typography.button,
    textTransform: 'uppercase',
    minHeight: theme.spacing(5),
    minWidth: theme.spacing(14),
    padding: theme.spacing(1.125, 2),
    fontWeight: theme.typography.fontWeightMedium,
    color: theme.palette.text.secondary,
    '&.Mui-selected': {
      color: theme.palette.primary.main
    }
  }
}));

export const ALLOCATION_PERIOD = {
  ENTIRE_PERIOD: 'ENTIRE_RANGE',
  MONTH: 'MONTHLY',
  WEEK: 'WEEKLY'
};

const getFormattedMessages = formatMessage => ({
  entirePeriod: formatMessage({ id: 'allocationByPeriod.tabs.entirePeriod' }),
  month: formatMessage({ id: 'allocationByPeriod.tabs.month' }),
  week: formatMessage({ id: 'allocationByPeriod.tabs.week' })
});

const AllocationPeriodTabs = ({
  selectedAllocationPeriod,
  onSelectedAllocationPeriodChange,
  ariaLabel
}) => {
  const { formatMessage } = useIntl();
  const classes = useStyles();
  const labels = getFormattedMessages(formatMessage);

  return (
    <Tabs
      value={selectedAllocationPeriod}
      onChange={onSelectedAllocationPeriodChange}
      className={classes.tabs}
      aria-label={ariaLabel}
    >
      <Tab
        value={ALLOCATION_PERIOD.ENTIRE_PERIOD}
        label={labels.entirePeriod}
        className={classes.tab}
        data-qe-id="AllocationPeriodTab_EntirePeriod"
      />
      <Tab
        value={ALLOCATION_PERIOD.MONTH}
        label={labels.month}
        className={classes.tab}
        data-qe-id="AllocationPeriodTab_Month"
      />
      <Tab
        value={ALLOCATION_PERIOD.WEEK}
        label={labels.week}
        className={classes.tab}
        data-qe-id="AllocationPeriodTab_Week"
      />
    </Tabs>
  );
};

AllocationPeriodTabs.propTypes = {
  selectedAllocationPeriod: PropTypes.oneOf(Object.values(ALLOCATION_PERIOD))
    .isRequired,
  onSelectedAllocationPeriodChange: PropTypes.func.isRequired,
  ariaLabel: PropTypes.string.isRequired
};

export default AllocationPeriodTabs;
